import {Component, input, signal} from '@angular/core';
import {AuthService, OAuthState} from "../../services/auth/auth.service";

@Component({
  selector: 'homey-login-with-apple-button',
  imports: [],
  standalone: true,
  templateUrl: './login-with-apple-button.component.html',
})
export class LoginWithAppleButtonComponent {
  public readonly oathState = input.required<OAuthState>();
  constructor(
    private readonly authService: AuthService,
  ) {
  }

  agreedToTerms = input.required<boolean>();
  loading = signal(false);

  async onLoginWithApple() {
    if (this.loading()) {
      return;
    }

    if (!this.agreedToTerms()) {
      alert('You must agree to the terms and conditions first');
      return;
    }
    this.loading.set(true);
    try {
      await this.authService.socialLogin(
        'apple',
        this.oathState(),
      );
    } finally {
      this.loading.set(false);
    }
  }
}
